/**
 * consumedCodes.js
 *
 * Tiny sessionStorage-based dedupe of OAuth authorization codes.
 * Prevents the same `?code=` from being exchanged twice when a user
 * refreshes the callback URL or hits the back-button.
 *
 * The list is capped at 20 entries to avoid unbounded growth in
 * long-lived tabs.
 */

const KEY = 'hai_job_consumed_oauth_codes';
const MAX = 20;

function read() {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || '[]');
  } catch {
    return [];
  }
}

function write(list) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(list));
  } catch {
    // sessionStorage full / unavailable, silently drop.
  }
}

export function isConsumed(code) {
  if (!code) return false;
  return read().includes(code);
}

export function markConsumed(code) {
  if (!code) return;
  const list = read();
  if (list.includes(code)) return;
  list.push(code);
  if (list.length > MAX) list.splice(0, list.length - MAX);
  write(list);
}
